import { render, staticRenderFns } from "./Flat.vue?vue&type=template&id=1c9cf0be"
import script from "./Flat.vue?vue&type=script&lang=ts"
export * from "./Flat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports